export interface Testimonial {
    id: number;
    name: string;
    text: string;
    date: string;
}

export const testimonialsData: Testimonial[] = [
    {
        id: 1,
        name: 'Radim L.',
        text: 'Používám Monery skoro každý den. Konečně appka, která dává smysl a není to další tabulka v Excelu. Mít všechny brokery na jednom místě je prostě paráda. 👌',
        date: '19.10.2025',
    },
    {
        id: 2,
        name: 'Tereza V.',
        text: 'Monery mi pomohlo konečně se zorientovat v investicích. Líbí se mi, že to vypadá moderně a ne jak starý bankovní systém. Jen bych chtěla víc barev v grafech 😄',
        date: '07.09.2025',
    },
    {
        id: 3,
        name: 'Pavel K.',
        text: 'Jsem s váma od bety a musím říct – jde to fakt správným směrem. Některé funkce by se ještě daly doladit, ale jinak klobouk dolů. Super práce!',
        date: '18.07.2025',
    },
    {
        id: 4,
        name: 'Matyáš S.',
        text: 'Zaplatil jsem si Monery před pár měsíci a fakt nelituju. Po načtení všech obchodů jsem měl konečně jasno, jak si co vede. Přidejte sektorový koláč a budu úplně spokojenej :)',
        date: '23.04.2025',
    },
    {
        id: 5,
        name: 'Jiří B.',
        text: 'Zadal jsem omylem budoucí datum a jeden obchod se mi nezapočítal, moje blbost 😅 Ale Monery funguje perfektně, jste borci, pokračujte dál!',
        date: '12.02.2025',
    },
    {
        id: 6,
        name: 'Lenka R.',
        text: 'Díky za možnost vyzkoušet Monery v betě. Vypadá to fakt dobře a všechno funguje jak má. Jen mi chvíli trvalo zadat všechny data, ale to je spíš moje lenost 😄',
        date: '08.12.2024',
    },
    {
        id: 7,
        name: 'Petr H.',
        text: 'Dobrý den, díky za super aplikaci. Všechno přehledné, jednoduché, žádné zbytečnosti. Přehled portfolia mám konečně pod kontrolou.',
        date: '27.09.2024',
    },
    {
        id: 8,
        name: 'Ondřej M.',
        text: 'Jasný, jsem s váma od začátku a budu do konce. :) Už mi to několikrát pomohlo s přehledem v portfoliu. Jen tak dál!',
        date: '05.07.2024',
    },
    {
        id: 9,
        name: 'Lucie P.',
        text: 'Na Monery jsem narazila přes kamaráda a nečekala jsem, že mě to bude tak bavit. Přehledné, funkční, a hlavně fakt hezky udělané UI.',
        date: '10.05.2024',
    },
];
